export const SET_NOTIFICATIONS_DATA = 'SET_NOTIFICATIONS_DATA';
export const SET_BLOCKER_COUNT = 'SET_BLOCKER_COUNT';

export const setNotificationsAction = payload => async dispatch => {
  dispatch({
    type: SET_NOTIFICATIONS_DATA,
    payload,
  });
};

export const setBlockerCountAction = payload => async dispatch => {
  dispatch({
    type: SET_BLOCKER_COUNT,
    payload,
  });
};
